/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "7d00b50a17c090be72e4105838cc136d7de80dab";
